// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.freemium.RentalManagerUserFreemiumWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserFreemiumWebApiHandler_details,
  RentalManagerUserFreemiumWebApiHandler_details_Path,
  RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible,
  RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { FreemiumDetailsResponseWebDto, ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';

interface DetailsParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserFreemiumWebApiHandler_details_Options = UseQueryOptions<
  FreemiumDetailsResponseWebDto,
  unknown,
  FreemiumDetailsResponseWebDto,
  readonly [string, DetailsParams]
>;

const RentalManagerUserFreemiumWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [RentalManagerUserFreemiumWebApiHandler_details_Path, getParams] as const;

export const RentalManagerUserFreemiumWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumWebApiHandler_details_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get freemium details for a listing
 */
export const useRentalManagerUserFreemiumWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumWebApiHandler_details.getKey = RentalManagerUserFreemiumWebApiHandler_details_GetKey;

export type RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string]
>;

const RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_GetKey = () =>
  [RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Path] as const;

export const RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_GetKey(),
    queryFn: () => RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get user's eligibility for top of funnel enrollment
 */
export const useRentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible.getKey =
  RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_GetKey;
